"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
const redux_1 = require("redux");
const reducer_1 = require("./by-customer-id/reducer");
const reducer_2 = require("./by-property-id/reducer");
exports.reducer = () => redux_1.combineReducers({
    byCustomerId: reducer_1.experimentsByCustomerIdReducer,
    byPropertyId: reducer_2.experimentsByPropertyIdReducer,
});
//# sourceMappingURL=reducer.js.map